import { format } from "date-fns";
import api, { formatApiErrorDetail } from "./api";

export const TIME_SLOTS = [
  "09:00", "09:30", "10:00", "10:30", "11:00", "11:30",
  "12:00", "12:30", "13:00", "13:30", "14:00", "14:30",
  "15:00", "15:30", "16:00", "16:30", "17:00", "17:30",
  "18:00", "18:30", "19:00",
];

export function validateBookingForm(form) {
  if (!form.name || !form.phone || !form.service_id || !form.date || !form.time) {
    return "Please complete all required fields.";
  }
  return null;
}

export async function submitBooking(form, services) {
  const service = services.find((s) => s.id === form.service_id);
  const payload = {
    name: form.name.trim(),
    phone: form.phone.trim(),
    email: form.email.trim() || null,
    service_id: form.service_id,
    service_name: service?.name || "",
    date: format(form.date, "yyyy-MM-dd"),
    time: form.time,
    notes: form.notes.trim(),
  };
  try {
    const { data } = await api.post("/bookings", payload);
    return { ok: true, booking: data };
  } catch (e) {
    return {
      ok: false,
      error: formatApiErrorDetail(e.response?.data?.detail) || "Booking failed.",
    };
  }
}
